import { Site } from '../../CommonTypes';

type SnippetArgs = {
  company: string;
  sitename: Site['sitename'];
  view?: string;
  type?: string;
};

export function buildEmbedSnippet({ company, sitename, view, type = 'widget' }: SnippetArgs) {
  if (type === 'iframe') {
    return `<iframe 
  src="https://bostad-cloud.pintar.se/${company}/${sitename}${view ? `/${view}` : ''}" 
  width="100%" 
  height="1100" 
></iframe>`;
  }

  if (type === 'link') {
    return `<a href="https://bostad-cloud.pintar.se/${company}/${sitename}${view ? `/${view}` : ''}" target="_blank"">
  Öppna i ny flik
</a>`;
  }

  // default: widget
  const attrs = [`company="${escapeHtml(company)}"`, `sitename="${escapeHtml(sitename)}"`];
  if (view) attrs.push(`view="${escapeHtml(view)}"`);

  const element = `<pintar-studios-webtools\n  ${attrs.join('\n  ')}\n>\n</pintar-studios-webtools>`;

  return [`<script async src="https://bostad-widget.pintar.se/widget.js"></script>`, '', element].join('\n');
}

export function cssPartSnippet() {
  const attrs = [
    `font-family: sans-serif, 'Poppins', Helvetica, Arial, Lucida;`,
    `font-weight: 500;`,
    `letter-spacing: 0.5px;`,
    `line-height: 1.7em;`,
    `font-size: 14px;`,
    `background-color: #f7f7f5 !important;`,
  ];
  const element = `pintar-studios-webtools::part(wrapper) {\n  ${attrs.join('\n  ')}\n}`;

  const attrs2 = [`background-color: #00965f;`];
  const element2 = `pintar-studios-webtools::part(view-border) {\n  ${attrs2.join('\n  ')}\n}`;

  const attrs3 = [`font-weight: 400;`, `background-color: #00965f;`, `color: white;`];
  const element3 = `pintar-studios-webtools::part(apartment-button) {\n  ${attrs3.join('\n  ')}\n}`;

  return [element, element2, element3].join('\n\n');
}

function escapeHtml(s: string) {
  return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
